import { defineMessages } from 'react-intl';

export default defineMessages({
  errorDescriptionFirst:
    'This transaction will fail. Please make sure you have enough {asset} and funds in the connected wallet for the transaction.',
  errorDescriptionSecond: '',
});
